import React from 'react';
import SbEditable from 'storyblok-react';
import styled from 'styled-components';

import Components from '../components';

const FluidContentBlock = (props) => {
  let backgroundColor = 'transparent';

  if (props.blok.background_color && props.blok.background_color.color !== '#f40000') {
    backgroundColor = props.blok.background_color.color;
  }

  return (
    <SbEditable content={props.blok}>
      <Container
        paddingV={props.blok.vertical_padding}
        paddingH={props.blok.horizontal_padding}
        backgroundColor={backgroundColor}
        zIndex={props.blok.z_index}
      >
        {props.blok.items.map((blok) =>
          React.createElement(Components(blok.component), { key: blok._uid, blok: blok })
        )}
      </Container>
    </SbEditable>
  );
};

const Container = styled.div`
  background-color: ${(props) => props.backgroundColor};
  padding: ${(props) => props.paddingV} ${(props) => props.paddingH} ${(props) => props.paddingV}
    ${(props) => props.paddingH};
  width: 100%;
  ${(props) => (props.zIndex ? `z-index: ${props.zIndex};position: relative;` : '')}
`;

export default FluidContentBlock;
